import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Button from '@mui/material/Button';
import { Box, Dialog, Divider, IconButton, TextField, Typography, Checkbox } from "@mui/material";
import Scrollbars from "rc-scrollbars";
import { NumInput, NumInputDesign, TextFeature, TextInput, TextInputDesign } from "./LittleComponents";
import _ from "lodash";
import { useLocalNotifications } from "components/Events";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getDataSource } from "api/ds";
import usePreventDoubleClick from "components/AntiDBC";
import { ReportTable } from "components/reportTable";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { get, getFile, post } from "api/apiBridges/httpBridge";
import { colors } from "styles/colors";
import { t } from "i18next";
import { ChangeOnlyDateMenu, ChangeOnlyDateMenuWithYear } from "utils/dndutils/cardformatters";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import ClassicSearch from "components/classicSearch";
import Loading from 'components/Load';
import { ShowModal } from "components/Modal";
import { hoverStyle } from "styles/main";

export default function ProductInfo({targetId, other, set, market, setChanged, close, isDefect}){

  const [loading, setLoading] = useState(false);
  const [localChanged, setLocalChanged] = useState(false);
  /** @type {[Object, Function]} */
  const [target, setTarget] = useState({});
  /** @type {[Array, Function]} */
  const [others, setOthers] = useState([]);
  /** @type {[any, Function]} */
  const [copyPath, setCopyPath] = useState(undefined);
  const [open, setOpen] = useState(false);
  const { user_id, company_id  } = useSelector(
    loginSelector
  );

  useEffect(() => {
    if (other) {
        let idx = other.findIndex((el) => el.id === targetId) 
        if (idx >-1) {
            let tmpData = JSON.parse(JSON.stringify(other[idx]))
            setTarget(tmpData)
        }
        setOthers(other)
    }
  }, [other, targetId]);


  const editNumValue = (path, val) => {
    let num = parseInt(val)
    if (!isNaN(num)) {
      const currentVal = _.get(target, path);
      if (currentVal === num) return;

      let tmp = JSON.parse(JSON.stringify(target))
      _.set(tmp, path, num)
      setTarget(tmp)
      setLocalChanged(true)
      if (setChanged) setChanged(true)    
    }
  }

  const editDateValue = (path, val) => {
      const currentVal = _.get(target, path);
      if (currentVal === val) return;

      let tmp = JSON.parse(JSON.stringify(target))
      _.set(tmp, path, val)
      setTarget(tmp)
      setLocalChanged(true)
      if (setChanged) setChanged(true)    
  }


  const copyFeatureOpen = (path) => {
    setCopyPath(path)
    setOpen(true)
  }

  const update = async (obj) => {
        

        let res = await post("Deal/updateOnNmAndSize", {
            user_id: user_id,
            nmID:obj.nmID, 
            deal_id:obj.deal_id,
            barcode:obj.size.barcode,
            countProduct:obj.countAllProduct.countProduct,
            countEtimated: obj.countAllProduct.countEtimated,
            countProductHist:obj.countAllProduct.countProductHist,
            countDefect:obj.countAllProduct.countDefect,
            box_id:obj.box_id,
            // autoPrice: obj.autoPrice,
            // addedPrice: obj.addedPrice,
            fixPrice: obj.fixPrice,
            inbox: obj.inbox,
            expiration_date:obj.data.expiration_date,
            expiration_time:obj.data.expiration_time,
        })
        //подумать, надо ли это тут, по идее можно внутри предыдущего метода
        await post("Deal/recalcProducts", {did: obj.deal_id})
        await post("product_settings/update", {barcode: obj.size.barcode, client_id: obj.qrcode.client_id, market, tz: obj.size.techTask.version, data: {inbox: obj.inbox}})
        obj.bind.map((el) => {post("Boxes/recalcProducts", {bid:el.box})}) 
        return res.updated
    }
  
    const refreshLocal = async (deal, vendor, cli, mr) => {
        const res = await get("Deal/GetDeliveryProductOnDeal", {did:deal})

        let result = []

        for (let card of res) {       
            console.log("card.id", card.id)
            let idx = others.findIndex((fel) => fel.size.barcode === card.size.barcode)
            let upobj = {
                id:card.id,
                nmID:card.nmID,
                deal_id: card.deal_id,
                data: {
                    market,
                    vendorCode:card.vendorCode,
                    brand:card.brand,
                    title:card.title,
                    photo:card.photo,
                    color:card.color,
                    dimensions: card.dimensions,
                    material:card.material,
                    barcode:card.size.barcode,
                    sizeTitle:card.size.title,
                    vendor: vendor,
                    expiration_date: card.expiration_date,
                    expiration_time: card.expiration_time,
                    nmID:card.nmID,
                    deal_id: card.deal_id,
                    user_id,
                    url: card.size.url,
                    urlID: card.size?.ozonID || card.nmID,
                    print:card.size.techTask?.print || "classic",
                    bcCopy: card.size.techTask?.services?.find((fel) => fel.name === 'Маркировка товара (ШК)')?.data.count || 0,
                    cli,
                    tz: card.size.techTask.version
                },

                countAllProduct:{
                    countProduct:card.countProduct,
                    countEtimated:card.countEtimated,
                    countDefect:card.countDefect,
                    countDefectHist:card.countDefectHist,
                    countProductHist:card.countProductHist,
                },

                packageFeatures:{
                    labelsCount:card.labelsCount,
                    craftCount:card.craftCount,
                    bookletCount:card.bookletCount,
                    zapayka:card.zapayka
                },

                // countProduct:card.countProduct,
                // countEtimated:card.countEtimated,
                // countDefect:card.countDefect,

                package:card.package,
                // tags:card.tags,

                // labelsCount:card.labelsCount,
                // craftCount:card.craftCount,
                // bookletCount:card.bookletCount,
                // zapayka:card.zapayka,
                inbox:card.inbox,
                
                services: card.services,
                // autoPrice: card.autoPrice,
                // addedPrice: card.addedPrice,
                fixPrice:card.fixPrice,

                dimensions:card.dimensions,
                size:card.size,
                qrcode:{id:card.id, qr: card.qr, nmID: card.nmID, size:card.size.barcode, count:card.qrCount,
                    //Ниже для логов
                    deal_id:card.deal_id, 
                    product: {
                        nmID: card.nmID,
                        barcode: card.size.barcode,
                        title: card.title,
                        vendorCode: card.vendorCode
                    },
                    user_id,
                    client_id: cli,
                    market:mr,
                    copyCount: card.size.techTask?.services?.find((fel) => fel.name === 'Маркировка товара (КИЗ)')?.data.count || 0,
                } ,
                // qrCount: card.qrCount,
                bind:card.bind,

                consumes: card.consumes,
                addit_cons: card.addit_cons,
                task_list: card.task_list
            }
            if (idx > -1 && market !== 'consum') {
                upobj.tz = others[idx].tz
            }
            result.push(upobj)
        }

        result = result.sort((a,b) => {return a.data.title - b.data.title})

        setOthers(result)
        set(result)
    }

    const save = async (obj) => {
        setLoading(true)
        await update(obj)

        await refreshLocal(obj.deal_id, obj.data.vendor, obj.qrcode.client_id, obj.qrcode.client_id.market)
        setLoading(false)
        close()
    }
    

    const copy = async (list, path, val) => {
        setLoading(true)
        let tmp = JSON.parse(JSON.stringify(others))
        for (let pid of list) {
            let idx = tmp.findIndex((el) => el.id === pid)
            if (idx>-1) {
                if (!_.isEqual(val, _.get(tmp[idx], path) )){
                    _.set(tmp[idx], path, val)
                    update(tmp[idx])
                }
            }
        }
        let idx = tmp.findIndex((el) => el.id === list[0])

        await refreshLocal(tmp[idx].deal_id, tmp[idx].data.vendor, tmp[idx].qrcode.client_id, tmp[idx].qrcode.client_id.market)
        setLoading(false)
    }

  const copyFeatures = (list) => {
    let val = _.get(target, copyPath)
    if (copy) {copy(list, copyPath, val)}
    setCopyPath(undefined)
    setOpen(false)
  }

  const handleClickSave = useCallback(async () => {
    save(target)
    setLocalChanged(false)
    if (setChanged) setChanged(false);
  }, [target, setChanged, save]);


  if (!target) { return <></>}

  //todo статусы
  if (loading) {
    return (<Loading></Loading>);
  }


  return (
    // <>{products.target}</>  
    //сделать везде нормальный путь
    <>
      <Dialog
          open={open}
          maxWidth='lg'
          PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
          onClose={() => { setOpen(false) }}
      >
          <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
              <SelectProductTocopy data={other?.filter((el) => el.id !== target?.id) || []} cancel={setOpen} onCopy={(list) => {copyFeatures(list)}}></SelectProductTocopy>
          </div>
      </Dialog>
      <div style={{height: "80%", marginTop:"15px", marginLeft:"10px"}}>
        <Scrollbars
          autoHide
          style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column"}}  
        >
          <div style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column", marginLeft:"5px"}}>
            {target?.countAllProduct?.countEtimated > 0 ?
                <>
                    <div style={{marginBottom: "10px"}}>
                        <TextInputDesign title={"Заявленное количество"} val={target?.countAllProduct?.countEtimated || 0} editable={false}></TextInputDesign>
                    </div>
                    <div style={{marginBottom: "10px", display: 'flex', justifyContent: 'space-between', flexDirection: "row", alignItems: "center"}}>
                        <NumInputDesign 
                            title={"Фактическое количество"} 
                            val={target?.countAllProduct?.countProduct || 0} 
                            onChange={(e) => editNumValue("countAllProduct.countProduct", e)}
                        />
                        <IconButton aria-label="copy" onClick={() => copyFeatureOpen("countAllProduct.countProduct")}>
                            <ContentCopyIcon
                                sx={{
                                    transition: 'all 0.3s ease',
                                    '&:hover': hoverStyle
                                }}
                            />
                        </IconButton>
                    </div>
                    
                </>                
                :
                <div style={{marginBottom: "10px"}}>
                    <TextInputDesign title={"Фактическое количество"} val={target?.countAllProduct?.countProduct || 0} editable={false}></TextInputDesign>
                </div>
            }
            {!isDefect && 
            <div style={{marginBottom: "10px", display: 'flex', justifyContent: "space-between", flexDirection: "row", alignItems: "center"}}>
              <NumInputDesign title={"Количество брака"} val={target?.countAllProduct?.countDefect} onChange={(e) => editNumValue("countAllProduct.countDefect", e)}></NumInputDesign>
              <IconButton aria-label="copy" onClick={() => copyFeatureOpen("countAllProduct.countDefect")}>
                  <ContentCopyIcon
                      sx={{
                          transition: 'all 0.3s ease',
                          '&:hover': hoverStyle
                      }}
                  />
              </IconButton>
            </div>
            }
          </div>
          <div style={{ marginTop: '10px', marginBottom: "15px", width: '100%' }}>
              <Divider orientation="horizontal" sx={{ borderRightWidth: "4px" }} />
          </div>
          <div style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column", marginLeft:"5px"}}>
            <div style={{marginBottom: "10px", display: 'flex', justifyContent: "space-between", flexDirection: "row", alignItems: "center"}}>
              <NumInputDesign title={"Стоимость обработки ед. товара"} val={target?.fixPrice} onChange={(e) => editNumValue("fixPrice", e)}></NumInputDesign>
              <IconButton aria-label="copy" onClick={() => copyFeatureOpen("fixPrice")}>
                  <ContentCopyIcon
                      sx={{
                          transition: 'all 0.3s ease',
                          '&:hover': hoverStyle
                      }}
                  />
              </IconButton>
            </div>
          </div>
          <div style={{ marginTop: '10px', marginBottom: "15px", width: '100%' }}>
              <Divider orientation="horizontal" sx={{ borderRightWidth: "4px" }} />
          </div>


            <div style={{marginLeft:"5px"}}>
                <div style={{marginBottom: "10px", display: 'flex', justifyContent: "space-between", flexDirection: "row", alignItems: "center"}}>
                    <NumInputDesign title={"Входит в короб"} val={target?.inbox || 0} onChange={(e) => editNumValue("inbox", e)}></NumInputDesign>
                    <IconButton aria-label="copy" onClick={() => copyFeatureOpen("inbox")}>
                        <ContentCopyIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                </div>
                <div style={{marginBottom: "10px", display: 'flex', justifyContent: "space-between", flexDirection: "row", alignItems: "center"}}>
                    <NumInputDesign title={"Срок годности (мес)"} val={target.data?.expiration_time || 0} onChange={(e) => editNumValue("data.expiration_time", e)}></NumInputDesign>
                    <IconButton aria-label="copy" onClick={() => copyFeatureOpen("data.expiration_time")}>
                        <ContentCopyIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                </div>
                <div style={{marginBottom: "10px", display: 'flex', justifyContent: "space-between", flexDirection: "row", alignItems: "center"}}>
                    <div style={{display: 'flex', flexDirection: "row", height: "30%", alignItems: "center"}}>
                        <Typography variant="body2" sx={{marginRight: "10px"}}>
                            Годен до: 
                        </Typography>
                        <ChangeOnlyDateMenuWithYear date={target.data?.expiration_date || Date()} handleUpdateCard={(date) => editDateValue('data.expiration_date', date.end_date)}/>
                    </div>
                    <IconButton aria-label="copy" onClick={() => copyFeatureOpen("data.expiration_date")}>
                        <ContentCopyIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                </div>
            </div>
        </Scrollbars>
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '95%', marginTop:'15px' }}>
            {localChanged? <Button 
                onClick={handleClickSave}
                variant="contained" 
                sx={{ 
                textTransform: 'none', 
                backgroundColor: colors.elements, 
                fontWeight: 'bold', 
                marginRight: '10px' 
                }} 
            >
                Применить
            </Button> : null}
        </div>
</div>
    </> 
  );
}

export function SelectProductTocopy({data, cancel, onCopy}) {
    console.log("SelectProductTocopy", data)
    /** @type {[Array, Function]} */
    const [$data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    // загрузка дескриптора
    const ds = useMemo(() => getDataSource('CopyProductsSelected'), []);
    
    //Настройки Фильтра
    /** @type {[Boolean, Function]} */
    const [checked, setChecked] = useState(false);
    /** @type {[Object, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
        }
    );

    const preventDoubleClick = usePreventDoubleClick();
    
    const onSelect = (select) => {
        setSelected(select);
    };

    const goCopy = async () => {
        onCopy(selected)
        cancel(false)
    }

    useEffect(() => {
        setData(data.map((el) => {return {...el}}))
    }, [data]);

    console.log("data SPTC", $data)

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
            }}
        >
            {/* Заголовок */}

            <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "text.primary",

                }}
            >
                {`${ds.descr.title}`}
            </Typography>


            {/* Поле поиска */}
            <ClassicSearch 
                setChecked={setChecked} 
                setFilter={setFilter} 
                checked={checked}
                // @ts-ignore
                fields={filterFields}
                // @ts-ignore
                setFields={setFilterFields}
            />

            {/* Таблица с прокруткой */}
            <Box
                sx={{
                    flex: 1,
                    overflow: "auto",
                    borderRadius: 2,
                }}
            >
                <ReportTable
                    ds={ds}
                    data={!checked? $data: $data.filter((el) => {const tf = filter.toLowerCase(); 
                    return (
                      filterFields.title.active &&
                        el.data.title &&
                        String(el.data.title).toLowerCase().includes(tf) || 
                      filterFields.brand.active &&
                        el.data.brand &&
                        String(el.data.brand).toLowerCase().includes(tf) || 
                      filterFields.vendorCode.active &&
                        el.data.vendorCode && 
                        String(el.data.vendorCode).toLowerCase().includes(tf) ||
                      filterFields.barcode.active &&
                        el.size.barcode &&
                        String(el.size.barcode).toLowerCase().includes(tf)
                    )})}
                    onSelect={onSelect}
                    // filterSettings={{active: checked, filter: filter.toLowerCase(), checkList: ["data.title", "data.brand", "data.vendorCode", "size.barcode"]}}
                />
            </Box>

            {/* Нижняя панель с кнопками и полем ввода */}
            <Box

                sx={{
                    mt: 'auto',
                    p: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    borderRadius: 2,
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "auto",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        onClick={preventDoubleClick(goCopy, 1000)}
                        variant="contained"
                        size="medium"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                        }}
                    >
                        Копировать
                    </Button>
                    <Button
                        onClick={() => cancel(false)}
                        variant="contained"
                        size="medium"
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            px: 3,
                            backgroundColor: "grey.500",
                            "&:hover": { backgroundColor: "grey.600" },
                        }}
                    >
                        Отмена
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}